// Веб-вклад модуля `notes` — конспекты.
//
// Две плитки воркспейса: «перечитать» (шаг ③, смена вида сцены) и «своя
// заметка» (шаги ①②, мутация `courses.createTopicNote`). Обе — поведение
// клиентского слоя; отсюда приходит только состав и порядок.

import { IconBook2, IconNote } from "@tabler/icons-react";
import { SECTION_CATEGORY, SECTION_ICONS } from "@/components/navigation/section-icons";
import type { WebModuleManifest } from "./_contract";

export const notesWebManifest = {
	id: "notes",
	icon: SECTION_ICONS.notes,
	labelKey: "nav.notes",
	category: SECTION_CATEGORY.notes,
	routes: ["/notes"],

	// Баннер РАЗГРАНИЧИВАЕТ конспект с исходником: слово «конспект» понятно, а
	// вот что это отдельный редактируемый документ поверх материала, а не его
	// копия в Библиотеке, — нет. Вкладка справки «Инструменты»: там видно, что
	// конспект и есть формат чтения темы.
	intro: {
		titleKey: "notes:intro.title",
		bodyKey: "notes:intro.body",
		bulletKeys: ["notes:intro.bullets.0", "notes:intro.bullets.1", "notes:intro.bullets.2"],
	},

	nav: [
		{
			key: "notes",
			to: "/notes",
			icon: SECTION_ICONS.notes,
			labelKey: "nav.notes",
			order: 20,
			badge: {
				kind: "powersync",
				sql: "SELECT count(*) FROM notes WHERE user_id = ? AND deleted_at IS NULL",
			},
		},
	],

	workspaceTools: [
		{
			key: "userNote",
			channel: "read",
			// Своя заметка — не «конспект раздела», а лист бумаги: знак отличается
			// от эмблемы раздела намеренно.
			icon: IconNote,
			steps: { 1: 60, 2: 50 },
		},
		{ key: "reread", channel: "read", icon: IconBook2, steps: { 3: 40 } },
	],
} satisfies WebModuleManifest;
